<template>
    <div class="list-group list-group-flush">
        <div class="list-group-item p-1" v-show="!district_prop">
            <div class="input-group m-0">
                <div class="input-group-append">
                    <span class="input-group-text">District</span>
                </div>
                <select class="form-control" v-model="district" :disabled="district_prop">
                    <option></option>
                    <option v-for="(d, indx) in locations" :value="d.id" :key="`district-${indx}`">{{ d.name }}</option>
                </select>
            </div>
        </div>
        <div class="list-group-item p-1" v-show="!county_prop">
            <div class="input-group m-0">
                <div class="input-group-append">
                    <span class="input-group-text">County</span>
                </div>
                <select class="form-control" v-model="county" :disabled="county_prop">
                    <option></option>
                    <option v-for="(d, indx) in counties" :value="d.id" :key="`county-${indx}`">{{ d.name }}</option>
                </select>
            </div>
        </div>
        <div class="list-group-item p-1">
            <div class="input-group m-0">
                <div class="input-group-append">
                    <span class="input-group-text">Sub County</span>
                </div>
                <select class="form-control" v-model="subCounty">
                    <option></option>
                    <option v-for="(d, indx) in sub_counties" :value="d.id" :key="`subCounty-${indx}`">{{ d.name }}</option>
                </select>
            </div>
        </div>
        <div class="list-group-item p-1">
            <div class="input-group m-0">
                <div class="input-group-append">
                    <span class="input-group-text">Parish</span>
                </div>
                <select class="form-control" v-model="parish">
                    <option></option>
                    <option v-for="(d, indx) in parishes" :value="d.id" :key="`parish-${indx}`">{{ d.name }}</option>
                </select>
            </div>
        </div>
        <div class="list-group-item p-1 border-bottom-0">
            <div class="input-group m-0">
                <div class="input-group-append">
                    <span class="input-group-text">Village</span>
                </div>
                <select class="form-control" v-model="village">
                    <option></option>
                    <option v-for="(d, indx) in villages" :value="d.id" :key="`village-${indx}`">{{ d.name }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import {createNamespacedHelpers} from 'vuex'

    const {mapState} = createNamespacedHelpers('loans');
    export default {
        name: "Locations",
        data() {
            return {
                district: '',
                county: '',
                subCounty: '',
                parish: '',
                village: ''
            }
        },
        props: {
            position: {
                type: String,
                required: true
            },
            district_prop: {
              type: String,
              required: false
            },
            county_prop: {
              type: String,
              required: false
            },
            subCounty_prop: {
              type: String,
              required: false
            },
            parish_prop: {
              type: String,
              required: false
            },
            village_prop: {
              type: String,
              required: false
            },
        },
        mounted() {
            if(this.district_prop) {
              this.district = this.district_prop;
            }
            if(this.county_prop) {
              this.county = this.county_prop;
            }
        },
        computed: {
            ...mapState(['locations']),
            district_() {
                if (this.district) {
                    return _.find(this.locations, (d) => {
                      return this.district.toString() === d.id.toString()
                    })
                }

                return null;
            },
            counties() {
                if (this.district_) {
                    return this.district_.counties;
                }

                return [];
            },
            county_() {
                if(this.county_prop && this.county !== this.county_prop) {
                  this.county = this.county_prop;
                }
                if (this.county) {
                    return _.find(this.counties, (d) => {
                        return this.county.toString() === d.id.toString()
                    })
                }

                return null;
            },
            sub_counties() {
                if (this.county_) {
                    return this.county_.sub_counties;
                }

                return [];
            },
            sub_county_() {
                if(this.subCounty_prop && this.subCounty !== this.subCounty_prop) {
                  this.subCounty = this.subCounty_prop;
                }
                if (this.subCounty) {
                    return _.find(this.sub_counties, (d) => {
                        return this.subCounty.toString() === d.id.toString()
                    })
                }

                return null;
            },
            parishes() {
                if (this.sub_county_) {
                    if(this.parish_prop && this.parish !== this.parish_prop) {
                      this.parish = this.parish_prop;
                    }
                    return this.sub_county_.parishes;
                }

                return [];
            },
            parish_() {
                if(this.parish_prop && this.parish !== this.parish_prop) {
                  this.parish = this.parish_prop;
                }
                if (this.parish) {
                    return _.find(this.parishes, (d) => {
                        return this.parish.toString() === d.id.toString()
                    })
                }

                return null;
            },
            villages() {
                if(this.village_prop && this.village !== this.village_prop) {
                  this.village = this.village_prop;
                }
                if (this.parish_) {
                    return this.parish_.villages;
                }

                return [];
            }
        },
        watch: {
            district() {
                this.county = '';
                this.subCounty = '';
                this.parish = '';
                this.village = '';
            },
            county() {
                this.subCounty = '';
                this.parish = '';
                this.village = '';
            },
            subCounty() {
                this.parish = '';
                this.village = '';
                this.$emit('subCounty', {position: this.position, subCounty: this.subCounty, parish: this.parish_prop, village: this.village_prop})
            },
            parish() {
                this.village = '';
                this.$emit('parish', {position: this.position, subCounty: this.subCounty, parish: this.parish, village: this.village_prop})
            },
            village() {
                this.$emit('village', {position: this.position, subCounty: this.subCounty, parish: this.parish, village: this.village})
            }
        }
    }
</script>

<style scoped>

</style>